import { GradientProgressBar } from "@/src/components/GradientProgressBar";
import { ospThemes } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/Home/MarketIndicators/AltcoinSeason/AltcoinSeasonH5";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface AltcoinSeasonH5Props {
  /** 标题 */
  title?: string;
  /** 当前值 */
  value?: number;
  /** 自定义类名 */
  className?: string;
  /** 标题自定义类名 */
  titleClassName?: string;
}

export const AltcoinSeasonH5: React.FC<AltcoinSeasonH5Props> = ({
  title = I18n.t("Altcoin Season Index"),
  value = 0,
  className,
  titleClassName,
}) => {
  return (
    <div className={cn("flex flex-col", className)}>
      {/* 标题 */}
      <h3
        aria-label="Altcoin Season H5 h3"
        data-openreplay-label="Altcoin Season H5 h3 Semantic"
        id="sem-altcoin-season-h5-h3"
        className={cn(
          "body_medium_s text-content_tertiary mb-[6px]",
          titleClassName,
        )}
      >
        {title}
      </h3>
      {/* 数值显示 */}
      <div className="flex items-center gap-1 mb-[10px]">
        <div className="body_bold_m text-content_primary">{value}</div>
        <div className="body_s text-content_tertiary">/100</div>
      </div>
      {/* 渐变进度条 */}
      <GradientProgressBar
        value={value}
        startColor={ospThemes.colors.content_accent5_primary}
        endColor={ospThemes.colors.content_aura_lv2_primary}
        sliderBorderColor={ospThemes.colors.background_solid_neutral_primary}
      />
      {/* 标签 */}
      <div className="flex justify-between mt-1">
        <span className="body_medium_xs text-content_tertiary">
          {I18n.t("Bitcoin")}
        </span>
        <span className="body_medium_xs text-content_tertiary">
          {I18n.t("Altcoin")}
        </span>
      </div>
    </div>
  );
};
